export enum CellType {
    Top = 1,
    Group = 2,
	Row = 3,
	Container = 4
}